import { computed, inject, readonly, reactive, toValue } from "vue";
import { useQuery } from "villus";
import { useAsyncData, useLazyAsyncData, useRoute } from "#app";
import hash from "../lib/hash.js";
import { dnGraphQlClient } from "../keys.js";
const defaultVillusOptions = {
  cachePolicy: "network-only"
};
export async function useAsyncQuery(villusOpts, nuxtOpts = {}) {
  const opts = { ...defaultVillusOptions, ...villusOpts };
  const route = useRoute();
  const key = computed(() => {
    const token = route?.query?.["x-craft-live-preview"];
    return hash({ ...opts, token });
  });
  const client = inject(dnGraphQlClient);
  if (!client) {
    throw new Error("Villus client could not be found, make sure to register the plugin correctly.");
  }
  const rOpts = readonly(reactive(opts));
  return useAsyncData(
    key,
    asyncHandler(client, villusOpts, nuxtOpts?.onComplete),
    {
      watch: [rOpts],
      ...nuxtOpts
    }
  );
}
export async function useLazyAsyncQuery(villusOpts, nuxtOpts = {}) {
  const opts = { ...defaultVillusOptions, ...villusOpts };
  const route = useRoute();
  const key = computed(() => {
    const token = route?.query?.["x-craft-live-preview"];
    return hash({ ...opts, token });
  });
  const client = inject(dnGraphQlClient);
  if (!client) {
    throw new Error("Villus client could not be found, make sure to register the plugin correctly.");
  }
  const rOpts = readonly(reactive(opts));
  return useLazyAsyncData(
    key,
    asyncHandler(client, villusOpts, nuxtOpts?.onComplete),
    {
      watch: [rOpts],
      ...nuxtOpts
    }
  );
}
function asyncHandler(client, villusOpts, onComplete) {
  return async () => {
    const response = await useQuery({
      ...villusOpts,
      ...{ client },
      paused: true
      // disable re-fetching feature of villus, Nuxt AsyncData will do this and call this callback if anything changes.
    });
    if (response?.error?.value) {
      const combinedError = response.error.value;
      const errorText = combinedError?.message ?? "Something went wrong";
      const errorMessage = combinedError?.response?.status ? `${errorText} [${combinedError.response.status}]` : errorText;
      throw new Error(errorMessage);
    }
    if (onComplete) {
      await onComplete(response);
    }
    return toValue(response?.data);
  };
}
